export default __webpack_public_path__ + "static/media/mother_and_son.ce54823c.jpg";